/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */
import { NewsItem } from '../types';
import { usePolicyState } from './usePolicyState';
import { usePolicyHandlers } from './usePolicyHandlers';

export function useGamePolicyBundle(addNewsItem: (item: NewsItem) => void) {
  const state = usePolicyState();
  const handlers = usePolicyHandlers({
    setPolicies: state.setPolicies,
    setPolicyChallenges: state.setPolicyChallenges,
    addNewsItem,
  });
  return { ...state, ...handlers };
}